import PractitionerProfileI, { CountryI } from "@interfaces/practitioner-profileI";
import { RootState } from "@redux/store";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const usePractitionerCountry = () => {
    const profile = useSelector((state: RootState) => state.practitionerProfile.profile);
    const [practitionerCountry, setPractitionerCountry] = useState<CountryI>()
    const [ hasLoaded, setHasLoaded ] = useState(false)

    const loadData = (profile:PractitionerProfileI) => {
        if (profile.practitionerAccreditations && profile.practitionerAccreditations.length) {
            const country = profile.practitionerAccreditations[0].country
            setPractitionerCountry(country)
        }
        setHasLoaded(true)
    }

    useEffect(() => {
        if (profile) {
            loadData(profile)
        }
    // eslint-disable-next-line
    }, [profile])

    return { practitionerCountry, hasLoaded }
}
export default usePractitionerCountry
